import React from 'react';
import styled from '@emotion/styled/macro';
import vars from '@variables';
import { ScaleProps } from './scale.types';

const PercentageGraphScale: React.FC<ScaleProps> = ({
  direction = 'horizontal',
  className,
}) => {
  if (direction === 'horizontal') {
    return (
      <svg
        className={className}
        viewBox="0 0 136 16"
        fill="none"
        preserveAspectRatio="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <title>Layer 1</title>
          <line
            x1="68.04179"
            y1="0.22331"
            x2="68.04179"
            y2="16.22331"
            stroke={vars.darkGrey}
            id="svg_1"
          />
          <line
            x1="13.70689"
            y1="2.22331"
            x2="13.70689"
            y2="14.22331"
            stroke={vars.dunedainGrey}
            id="svg_2"
          />
          <line
            x1="27.13119"
            y1="2.22331"
            x2="27.13119"
            y2="14.22331"
            stroke={vars.dunedainGrey}
            id="svg_3"
          />
          <line
            x1="40.55599"
            y1="2.22331"
            x2="40.55599"
            y2="14.22331"
            stroke={vars.dunedainGrey}
            id="svg_4"
          />
          <line
            x1="54.93979"
            y1="2.22331"
            x2="54.93979"
            y2="14.22331"
            stroke={vars.dunedainGrey}
            id="svg_5"
          />
          <line
            x1="81.78889"
            y1="2.22331"
            x2="81.78889"
            y2="14.22331"
            stroke={vars.dunedainGrey}
            id="svg_6"
          />
          <line
            x1="95.21369"
            y1="2.22331"
            x2="95.21369"
            y2="14.22331"
            stroke={vars.dunedainGrey}
            id="svg_7"
          />
          <line
            x1="122.06309"
            y1="2.22331"
            x2="122.06309"
            y2="14.22331"
            stroke={vars.dunedainGrey}
            id="svg_8"
          />
          <line
            x1="108.63809"
            y1="2.22331"
            x2="108.63809"
            y2="14.22331"
            stroke={vars.dunedainGrey}
            id="svg_9"
          />
          <line
            x1="0.29964"
            y1="0.22331"
            x2="0.29964"
            y2="16.22331"
            id="svg_10"
            stroke={vars.darkGrey}
          />
          <line
            x1="135.78309"
            y1="0.22331"
            x2="135.78309"
            y2="16.22331"
            stroke={vars.darkGrey}
            id="svg_11"
          />
        </g>
      </svg>
    );
  } else if (direction === 'vertical') {
    return (
      <svg
        version="1.2"
        baseProfile="tiny-ps"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 16 136"
        width="16"
        height="136"
      >
        <title>Scales-svg</title>
        <style>tspan </style>
        <g>
          <path
            className="shp0"
            d="M15.78 68.04L-0.22 68.04"
            stroke={vars.darkGrey}
          />
          <path
            className="shp1"
            d="M13.78 13.71L1.78 13.71"
            stroke={vars.dunedainGrey}
          />
          <path
            className="shp1"
            d="M13.78 27.13L1.78 27.13"
            stroke={vars.dunedainGrey}
          />
          <path
            className="shp1"
            d="M13.78 40.56L1.78 40.56"
            stroke={vars.dunedainGrey}
          />
          <path
            className="shp1"
            d="M13.78 54.94L1.78 54.94"
            stroke={vars.dunedainGrey}
          />
          <path
            className="shp1"
            d="M13.78 81.79L1.78 81.79"
            stroke={vars.dunedainGrey}
          />
          <path
            className="shp1"
            d="M13.78 95.21L1.78 95.21"
            stroke={vars.dunedainGrey}
          />
          <path
            className="shp1"
            d="M13.78 122.06L1.78 122.06"
            stroke={vars.dunedainGrey}
          />
          <path
            className="shp1"
            d="M13.78 108.64L1.78 108.64"
            stroke={vars.dunedainGrey}
          />
          <path
            className="shp0"
            d="M15.78 0.3L-0.22 0.3"
            stroke={vars.darkGrey}
          />
          <path
            className="shp0"
            d="M15.78 135.78L-0.22 135.78"
            stroke={vars.darkGrey}
          />
        </g>
      </svg>
    );
  } else {
    console.warn('Single bar graph scale: invalid or missing direction prop');
    return null;
  }
};

const PercentageGraphScaleAtom = styled(PercentageGraphScale)``;

export default PercentageGraphScaleAtom;
